import type { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Logo from "@assets/misc/logo.webp";

import { StyledErrorFallback } from "./ErrorFallback.styled";


export function Fallback({ error }: FallbackProps) {
  const { t } = useTranslation();

  return (
    <StyledErrorFallback>
      <div className="content">
        <div className="logo">
          <img src={Logo} alt="La Ruche Health" />
        </div>
        <h1 className="heading">{t("internal-error-title")}</h1>
        <p className="description">{t("internal-error-description")}</p>

        {/* <Button onClick={resetErrorBoundary}>Try Again</Button> */}
        <button className="cta" onClick={() => window.location.reload()}>
          {t("refresh-page")}
        </button>

        {/* Show error details in development */}
        {import.meta.env.DEV && (
          <div className="error">
            <details>
              <summary
                style={{
                  fontSize: 15,
                  cursor: "pointer",
                  color: "#e74c3c",
                  marginBottom: "10px",
                }}>
                Error Details [DEV]
              </summary>
              <pre
                style={{
                  backgroundColor: "#f8f8f8",
                  padding: "10px",
                  borderRadius: "4px",
                  overflow: "auto",
                  fontSize: "12px",
                  whiteSpace: "pre-wrap",
                }}>
                {error?.message}
                {"\n\n"}
                {error?.stack}
              </pre>
            </details>
          </div>
        )}
      </div>

      <div className="support">
        <p>
          <span>{t("support")}:</span>&nbsp;+225 05 02 87 68 87 •&nbsp;
          <Link to="mailto:engineering@laruche.health">
            engineering@laruche.health
          </Link>
        </p>
      </div>
    </StyledErrorFallback>
  );
}
